import { KlarnaPaymentMessageUI } from "./KlarnaPaymentMessageUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant";
import { ensureIsActive } from "@/utils/product/ensureIsActive";
import { CreditIllustration } from "@/types/cobeTypes";
import { recordImpressionByParam } from "@JohnLewisPartnership/experiments-utils";

export function KlarnaPaymentMessage({
  product,
  creditOffersV2,
  runtimeConfig,
  flags,
  experiencesRawObject,
}: Pick<
  StandardProps,
  | "product"
  | "creditOffersV2"
  | "runtimeConfig"
  | "flags"
  | "experiencesRawObject"
>) {
  const { isSelected, variant } = useVariant(product);

  const showKlarnaMessage = !!flags.showKlarnaMessage.value;

  const activeProduct = ensureIsActive(product);

  if (!activeProduct || !isSelected) {
    return null;
  }

  const eligibleForKlarna = creditOffersV2?.find(
    ({ skuId, creditIllustrations }) => {
      const hasKlarnaOffer = creditIllustrations.find(
        (illustration: CreditIllustration) =>
          illustration.creditProvider.toLowerCase() === "klarna",
      );
      return skuId === variant.aliases.skuId && hasKlarnaOffer;
    },
  );

  if (eligibleForKlarna) {
    recordImpressionByParam(
      runtimeConfig?.monetateEnvironment,
      experiencesRawObject as [],
      "pdp-scaffold-showKlarnaMessage",
      showKlarnaMessage.toString(),
    );
  } else return null;

  return (
    showKlarnaMessage && (
      <KlarnaPaymentMessageUI
        runtimeConfig={runtimeConfig}
        currentPrice={variant.price?.value}
        isSelected={isSelected}
      />
    )
  );
}
